const SET_FORM_TAMBAH_MOBIL = 'SET_FORM_TAMBAH_MOBIL';
const SET_OPTIONS_FORM_TAMBAH_MOBIL = 'SET_OPTIONS_FORM_TAMBAH_MOBIL';
const SET_BOOKING_SERVICE_STATE = 'SET_BOOKING_SERVICE_STATE';
const SET_FORM_BRANCH = 'SET_FORM_BRANCH';
const SET_FORM_ADDRESS = 'SET_FORM_ADDRESS';
const SET_FORM_TIME = 'SET_FORM_TIME';
const SET_IS_OPEN_MODAL_VEHICLE_INFORMATION = 'SET_IS_OPEN_MODAL_VEHICLE_INFORMATION';
const SET_INITIAL_STATE_FORM_VALUE = 'SET_INITIAL_STATE_FORM_VALUE';
const SET_INITIAL_FORM_BRANCH_TIME = 'SET_INITIAL_FORM_BRANCH_TIME';
const SET_INIT_VALUE_CONFIRMATION_MODAL = 'SET_INIT_VALUE_CONFIRMATION_MODAL';
const RESET_STATE_SERVICES_STATE = 'RESET_STATE_SERVICES_STATE';
const RESET_STATE_BRANCH_TIME_STATE = 'RESET_STATE_BRANCH_TIME_STATE';
const RESET_ONE_STATE_SERVICES_STATE = 'RESET_ONE_STATE_SERVICES_STATE';
const RESET_ALL = 'RESET_ALL';
const SET_VISIBLE_GLOBAL_ERROR_MODAL = 'SET_VISIBLE_GLOBAL_ERROR_MODAL';
const SET_STNK_EXPIRY_DATE = 'SET_STNK_EXPIRY_DATE';
const SET_DISPLAY_DETAIL_VOUCHER = 'SET_DISPLAY_DETAIL_VOUCHER';
const SET_SHOW_TCARE_INFO_MODAL = 'SET_SHOW_TCARE_INFO_MODAL';

export {
  SET_FORM_TAMBAH_MOBIL,
  SET_OPTIONS_FORM_TAMBAH_MOBIL,
  SET_BOOKING_SERVICE_STATE,
  SET_FORM_BRANCH,
  SET_FORM_ADDRESS,
  SET_FORM_TIME,
  SET_IS_OPEN_MODAL_VEHICLE_INFORMATION,
  SET_INITIAL_STATE_FORM_VALUE,
  SET_INITIAL_FORM_BRANCH_TIME,
  SET_INIT_VALUE_CONFIRMATION_MODAL,
  RESET_STATE_SERVICES_STATE,
  RESET_ONE_STATE_SERVICES_STATE,
  RESET_ALL,
  SET_VISIBLE_GLOBAL_ERROR_MODAL,
  RESET_STATE_BRANCH_TIME_STATE,
  SET_STNK_EXPIRY_DATE,
  SET_DISPLAY_DETAIL_VOUCHER,
  SET_SHOW_TCARE_INFO_MODAL,
};
